var _circle, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgRadioButton = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 8,
  r: 7.5,
  stroke: "#050505"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 8,
  r: 5,
  fill: "#050505"
})));
export { SvgRadioButton as ReactComponent };
export default __webpack_public_path__ + "195e227c06ddfe3a0821e84ebd0038a9.svg";